export const apiUrl = process.env.REACT_APP_API_URL;
export const appUrl = process.env.REACT_APP_URL;
